/* eslint-disable */
import React, { startTransition, useEffect, useState } from "react";
import { utility } from "../../framework/utility/utilityProvider";
import { ENTITYNAME, EXPORT_TYPE, FILEURL, getPublishReportConfig, LOCALSTORAGE_KEY, MODULETYPES, PLANNING_EXPORT, PUBLISH_REPORT, PUBLISH_REPORT_CONFIG, PUBLISH_TYPE, REPORT_TYPE, SCHEDULETYPE, SLOT_TIMES, TOAST_TYPES } from "../../framework/constant/constant";
import { useTranslation } from "../../locale/useTranslation";
import { DropDownList } from "@progress/kendo-react-dropdowns";
import * as API from "../../framework/API/api";
import moment from "moment";
import BossDialog from "../../components/BossDialog";
import { Checkbox } from "@progress/kendo-react-inputs";
import { PlanningHelper } from "./helper/PlanningHelper";
import ToastNotification from "../../components/ToastNotification";
const PlannerExportExcelForm = (props) => {

    const { closeExcelPopup, ChannelList, exportChannel, setExportChannel, slotDuration } = props;
    const lang = useTranslation();

    const company = utility.getValue(LOCALSTORAGE_KEY.COMPANY);

    const [dataItem, setDataItem] = useState({ PlanningExport: { _id: PLANNING_EXPORT.ExcelPlannerGrid, Description: utility.getKeyByValue(PLANNING_EXPORT, PLANNING_EXPORT.ExcelPlannerGrid) }, ReportType: {}, timeZoneOffset: null });
    const [planningExports, setPlanningExports] = useState([]);

    const [excelFromDate, setExcelFromDate] = useState(new Date());
    const [excelToDate, setExcelToDate] = useState(new Date(Date.now() + 7 * 24 * 60 * 60 * 1000));

    const [durationType, setDurationType] = useState("Nominal");
    const [startType, setStartType] = useState("Nominal");
    const [isExportingMessage, setIsExportingMessage] = useState(false);
    const [hideNextDayShowContinuation, setHideNextDayShowContinuation] = useState(false);
    const [showTitleOnly, setShowTitleOnly] = useState(false);
    const [showPgRating, setShowPgRating] = useState(false);
    const [isMonthExport, setIsMonthExport] = useState(false);
    const [publishReports, setPublishReports] = useState([]);
    const [epgColumns, setEpgColumns] = useState([]);
    const [epgColumn, setEpgColumn] = useState({});
    const [slotDur, setSlotDur] = useState(slotDuration ?? 60);
    const [timeZones, setTimeZones] = useState([]);
    const [isTimeZone, setIsTimeZone] = useState(false);

    useEffect(() => {
        loadCombo();
    }, []);

    const loadCombo = async () => {

        //Planning Export Options
        const planningExportRes = Object.keys(PLANNING_EXPORT).map((x) => ({
            _id: PLANNING_EXPORT[x],
            Description: x
        }));
        setPlanningExports(planningExportRes);

        //Reports for Custom EPG
        const companyName = company?.Name?.toLowerCase()?.trim();
        const epgReports = (PUBLISH_REPORT_CONFIG ?? []).filter((x) => x?.PUBLISH_TYPE === PUBLISH_TYPE.EPGs);
        const companyReports = epgReports.some((x) => {
            return x?.clients.some((client) => !["generic", "no_client"].includes(client) && client?.toLowerCase()?.trim() === companyName);
        });
        const reports = epgReports.filter((x) => {
            if (companyReports) {
                return x?.clients.some((client) => client?.toLowerCase()?.trim() === companyName);
            }
            return null;
        });
        setPublishReports(reports);



        let epgExportRes = await API.getData(ENTITYNAME.ExportTemplate, { sort: { Name: 1 }, query: [['ModuleType.SID', '=', MODULETYPES[6].SID], ["Archive", "!=", true]] });
        setEpgColumns(epgExportRes.data);

        let timeZonesRes = await API.getData(ENTITYNAME.TimeZone, { sort: { Description: 1 } });
        setTimeZones(timeZonesRes.data);

    };

    const onChange = (e) => {
        const { name, value } = e.target;
        if (name === "PlanningExport") {
            setEpgColumn(null);
            setDataItem({ ...dataItem, PlanningExport: value, ReportType: null });
            return;
        }
        setDataItem({ ...dataItem, [name]: value });
    };

    const onStartTypeChange = (value) => {
        setStartType(value);
    };

    const onDurationTypeChange = (value) => {
        setDurationType(value);
    };

    const isValid = () => {

        if (excelFromDate > excelToDate) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.from_date_cant_be_greater_than_to_date_paste_planner_error_message });
            return false;
        }

        if (!exportChannel && Object.keys(exportChannel).length == 0) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_channel_error_message });
            return false;
        }

        const isCustomEPG = dataItem?.PlanningExport?._id === PLANNING_EXPORT.CustomEPG;
        const isEXCELORCSV = (dataItem?.PlanningExport?._id === PLANNING_EXPORT.CSVEPG) || (dataItem?.PlanningExport?._id === PLANNING_EXPORT.ExcelEPG);
        const isReportTypeMissing = !dataItem?.ReportType || Object.keys(dataItem.ReportType).length === 0;
        const isTemplateMissing = epgColumn == null || Object.keys(epgColumn).length === 0;

        if (isCustomEPG && isReportTypeMissing) {
            if (publishReports && publishReports.length == 0) {
                ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: "On custom EPG report to export" });
                return false
            } else {
                ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_report_type_error_message });
                return false;
            }
        }

        if ((isEXCELORCSV && isTemplateMissing)) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: "Please select EPG template to export" });
            return false;
        }

        console.log("dataitem", dataItem);

        return true;

    }

    const handleExportEpg = () => {
        if (!isValidChannel()) return
        if (!isValid()) return;

        let reportType = PUBLISH_REPORT.XLSX; // default

        if (dataItem?.PlanningExport?._id === PLANNING_EXPORT.CSVEPG) {
            reportType = PUBLISH_REPORT.CSV;
        }
        else if (dataItem?.PlanningExport?._id === PLANNING_EXPORT.ExcelEPG) {
            reportType = PUBLISH_REPORT.XLSX;
        }
        else if (dataItem?.PlanningExport?._id === PLANNING_EXPORT.CustomEPG) {
            reportType = dataItem.ReportType._id;
        }
        handleExport(EXPORT_TYPE.EPG, reportType);
    }

    const exportExcel = async (exportPDF = false) => {
        if (excelFromDate > excelToDate) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.from_date_cant_be_greater_than_to_date_paste_planner_error_message });
            return;
        }

        setIsExportingMessage(true);

        const preferenceData = utility.getValue(LOCALSTORAGE_KEY.planningpreference);
        // const offSetHours = new Date(preferenceData?.data[0]?.value?.TimeZone?.DayStartTime ?? 0).getUTCHours();
        const offSetHours = new Date(PlanningHelper.getDayStartTime([exportChannel]) ?? 0).getUTCHours();
        const offsetTime = offSetHours * 3600000;
        let planningpreference = utility.getValue(LOCALSTORAGE_KEY.planningpreference)?.data[0]?.value;
        planningpreference = {
            EventStyle: planningpreference?.EventStyle,
            GenreStyle: planningpreference?.GenreStyle,
            IsGenreColorPreference: planningpreference?.IsGenreColorPreference,
            priotizeMediaColor : planningpreference?.priotizeMediaColor ?? false
        }

        var payload = {
            param: {
                query: {
                    fromDate: new Date(excelFromDate.setUTCHours(0, 0, 0, 0)).getTime(),
                    toDate: new Date(excelToDate.setUTCHours(23, 59, 59, 99)).getTime(),
                    channelSID: [exportChannel?.SID],
                }
            },
            columns: epgColumn?.Columns && epgColumn?.Columns?.length > 0 ? epgColumn?.Columns?.map(x => x?.AvailableColumn) : [],
            slotDuration: slotDur ?? 15,
            planningPreference: { ...planningpreference, weekStartDay: utility.getValue(LOCALSTORAGE_KEY.planningpreference)?.data[0]?.value?.weekStartDay, },
            selectedColumns: utility.getValue(LOCALSTORAGE_KEY.planningpreference)?.data[0]?.value?.SelectedColumns,
            offsetTime: offsetTime,
            isNominalDuration: durationType != "ActualDuration" ? true : false,
            isNominalStart: startType == "Nominal",
            skipNextDayContinuation: hideNextDayShowContinuation ?? false,
            showTitleOnly: showTitleOnly ?? false,
            showPgRating: showPgRating ?? false,
            isMonthExport: isMonthExport ?? false,
            timeZoneOffset: isTimeZone && dataItem?.timeZoneOffset ? (dataItem?.timeZoneOffset?.IsNegativeOffset ? -1 * dataItem?.timeZoneOffset?.Offset : dataItem?.timeZoneOffset?.Offset) : 0
        }
        console.log(payload);

        var res = exportPDF ? await API.exportPDF(payload) : await API.exportPlanning(payload);
        console.log(res);
        if (res.success) {
            var filePath = FILEURL().BASEURL + 'downloadReport/' + res.data;
            const downloadTab = window.open(filePath, '_blank');
            setTimeout(() => {
                if (downloadTab && !downloadTab.closed) {
                    downloadTab.close();
                }
            }, 2000);
        }
        else {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: res.message });
        }
        setIsExportingMessage(false);

    }

    const exportEPG = async (reportType = PUBLISH_REPORT.XLSX) => {
        if (excelFromDate > excelToDate) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.from_date_cant_be_greater_than_to_date_paste_planner_error_message });
            return;
        }

        setIsExportingMessage(true);

        const preferenceData = utility.getValue(LOCALSTORAGE_KEY.planningpreference);
        const offSetHours = new Date(preferenceData?.data[0]?.value?.TimeZone?.DayStartTime ?? 0).getUTCHours();
        const offsetTime = offSetHours * 3600000;

        let fromDate = new Date(excelFromDate.setUTCHours(0, 0, 0, 0)).getTime();
        let toDate = new Date(excelToDate.setUTCHours(23, 59, 59, 99)).getTime();

        let payload = {};
        let res = null;

        console.log(epgColumn)

        if (epgColumn && Object.keys(epgColumn).length > 0) {
            payload = {
                reportType: getPublishReportConfig(reportType).Description,
                param: {
                    sort: { SlotDateTime: 1 },
                    tableName: epgColumn.ModuleType.SaveEntityName,
                    query: [['SlotDateTime', '>=', fromDate], ['SlotDateTime', '<=', toDate], ['Type', '=', SCHEDULETYPE.Header]],
                    customColumns: epgColumn.Columns,
                    companyTimeZone: company?.TimeZone,
                    dateWiseSheet: false
                },
                Dates: {
                    FromDate: fromDate,
                    ToDate: toDate
                },
                TemplateName: epgColumn.Name,
                channels: [exportChannel]
            }

            res = await API.getEPGReports(payload);

        }
        else if (dataItem?.PlanningExport?._id === PLANNING_EXPORT.CustomEPG) {

            payload = {
                reportType: dataItem?.ReportType.Description,
                param: {
                    query: {
                        fromDate: fromDate,
                        toDate: toDate, // Adding 1 Day To Cater End Date
                        channels: [exportChannel],
                        offsetTime: offsetTime,
                    }
                }
            }

            res = await API.getEPGReports(payload);

        }
        else {

            payload = {
                param: {
                    query: {
                        fromDate: fromDate,
                        toDate: toDate, // Adding 1 Day To Cater End Date
                        channelSID: exportChannel.SID,
                        offsetTime: offsetTime,
                    }
                }

            }

            res = await API.exportEPG(payload);

        }

        console.log(res);
        if (res?.success && Array.isArray(res?.data) && res?.data?.length > 0) {
            let filename = res?.data[0]?.data;

            const newWindow = window.open(
                FILEURL().BASEURL + 'downloadReport/' + filename,
                "_blank"
            );
            setTimeout(() => {
                if (newWindow && !newWindow.closed) {
                    newWindow.close();
                }
            }, 2000);
        }
        else if (res && res.success) {
            const filePath = FILEURL().BASEURL + 'downloadReport/' + res.data;

            const downloadWindow = window.open(filePath, "_blank");
            setTimeout(() => {
                if (downloadWindow && !downloadWindow.closed) {
                    downloadWindow.close();
                }
            }, 2000);
        } else {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: res.message });
        }
        setIsExportingMessage(false);
    }

    const isValidChannel = () => {
        if (Object.keys(exportChannel).length == 0) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_channel_error_message });
            return false;
        }
        return true;
    }

    const handleExport = async (exportType, reportType) => {
        if (!isValidChannel()) return
        switch (exportType) {
            case EXPORT_TYPE.EXCEL:
                await exportExcel();
                break;
            case EXPORT_TYPE.EPG:
                await exportEPG(reportType);
                break;
            case EXPORT_TYPE.PDF:
                await exportExcel(true);
                break;

            default:
                exportExcel();
                break;
        }

    }

    const handleExportBreakPattern = async () => {
        if (excelFromDate > excelToDate) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.from_date_cant_be_greater_than_to_date_paste_planner_error_message });
            return;
        }
        setIsExportingMessage(true);
        const preferenceData = utility.getValue(LOCALSTORAGE_KEY.planningpreference);
        const offSetHours = new Date(PlanningHelper.getDayStartTime([exportChannel]) ?? 0).getUTCHours();
        const offsetTime = offSetHours * 3600000;
        let payload = {
            fromDate: new Date(excelFromDate.setUTCHours(0, 0, 0, 0)).getTime() + offsetTime,
            toDate: new Date(excelToDate.setUTCHours(23, 59, 59, 99)).getTime() + offsetTime,
            channelSID: exportChannel?.SID,
        }
        let res = await API.exportBreakPattern(payload);
        console.log(res);

        if (res.success) {
            const newTab = window.open(
                FILEURL().BASEURL + 'downloadReport/' + res.data, '_blank');
            setTimeout(() => { newTab?.close() }, 2000
            );
            ToastNotification({ type: TOAST_TYPES.SUCCESS, title: lang.success_message_title, message: lang.successfully_exported_success_message });
        } else {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: res.message });
        }
        setIsExportingMessage(false);
    }

    return (
        <BossDialog title={lang.planning_export_dialog_header} width={"900px"} onClose={closeExcelPopup}>

            <div className="row align-items-end mb-4">
                <div className="col-md-4">
                    <label className="form-label fw-semibold"> {lang.planning_export_label} </label>
                    <DropDownList
                        data={planningExports}
                        textField="Description"
                        name="PlanningExport"
                        dataItemKey="_id"
                        value={dataItem.PlanningExport}
                        onChange={onChange}
                        style={{ width: "100%" }}
                        disabled={isExportingMessage}
                    />
                </div>
                <div className="col-md-8 d-flex gap-2">
                    {dataItem?.PlanningExport?._id === PLANNING_EXPORT.ExcelPlannerGrid && (
                        <button className="btn btn-outline-success d-flex align-items-center gap-2" title={lang.export_excel_button_tooltip} style={{ borderRadius: "4px" }} onClick={() => handleExport(EXPORT_TYPE.EXCEL)} disabled={isExportingMessage}>
                            <i className="fa fa-file-excel"></i>
                        </button>
                    )}
                    {dataItem?.PlanningExport?._id === PLANNING_EXPORT.PDFPlannerGrid && (
                        <button className="btn btn-outline-danger d-flex align-items-center gap-2" title={lang.export_pdf_button} style={{ borderRadius: "4px" }} onClick={() => handleExport(EXPORT_TYPE.PDF)} disabled={isExportingMessage} >
                            <i className="fa fa-file-pdf"></i>
                        </button>
                    )}
                    {(dataItem?.PlanningExport?._id === PLANNING_EXPORT.CSVEPG ||
                        dataItem?.PlanningExport?._id === PLANNING_EXPORT.ExcelEPG || dataItem?.PlanningExport?._id === PLANNING_EXPORT.CustomEPG) && (
                            <button className="btn btn-outline-primary d-flex align-items-center gap-2" style={{ borderRadius: "4px" }} onClick={handleExportEpg} title={lang.export_epg_button_text} disabled={isExportingMessage}>
                                <i className="fa fa-download"></i>
                            </button>
                        )}
                    {dataItem?.PlanningExport?._id === PLANNING_EXPORT.BreakPattern && (
                        <button className="btn btn-outline-success d-flex align-items-center gap-2" title={lang.export_break_pattern_button} style={{ borderRadius: "4px" }} onClick={handleExportBreakPattern} disabled={isExportingMessage}>
                            <i className="fa fa-file-excel"></i>
                        </button>
                    )}
                </div>
                {isExportingMessage && (
                    <div className="col-12 mt-2 text-end text-primary fw-semibold">
                        Exporting... Please wait
                    </div>
                )}
            </div>
            {(dataItem?.PlanningExport?._id === PLANNING_EXPORT.ExcelPlannerGrid ||
                dataItem?.PlanningExport?._id === PLANNING_EXPORT.PDFPlannerGrid ||
                dataItem?.PlanningExport?._id === PLANNING_EXPORT.CSVEPG ||
                dataItem?.PlanningExport?._id === PLANNING_EXPORT.ExcelEPG ||
                dataItem?.PlanningExport?._id === PLANNING_EXPORT.BreakPattern ||
                dataItem?.PlanningExport?._id === PLANNING_EXPORT.CustomEPG) && (

                    <div className="border rounded p-3 mb-3 bg-light">
                        <div className="row g-3">
                            <div className="col-md-4">
                                <label className="form-label fw-semibold"> {lang.channel_label} * </label>
                                <DropDownList
                                    data={ChannelList}
                                    textField="name"
                                    dataItemKey="_id"
                                    value={exportChannel}
                                    onChange={(e) => { startTransition(() => setExportChannel(e.target.value)) }}
                                    style={{ width: "100%" }}
                                    disabled={isExportingMessage}
                                />
                            </div>
                            <div className="col-md-4">
                                <label className="form-label fw-semibold"> {lang.from_label} </label>
                                <input
                                    name="From"
                                    placeholder=""
                                    type="date"
                                    className="form-control form-control-sm"
                                    value={moment(excelFromDate).utc().format('YYYY-MM-DD')}
                                    onChange={(e) => startTransition(() => setExcelFromDate(new Date(e.target.value)))}
                                />
                            </div>
                            <div className="col-md-4">
                                <label className="form-label fw-semibold"> {lang.to_label}</label>
                                <input
                                    name="To"
                                    placeholder=""
                                    type="date"
                                    className="form-control form-control-sm"
                                    value={moment(excelToDate).utc().format('YYYY-MM-DD')}
                                    onChange={(e) => startTransition(() => setExcelToDate(new Date(e.target.value)))}
                                />
                            </div>
                            {/* ===== Planner Fields ===== */}
                            {(dataItem?.PlanningExport?._id === PLANNING_EXPORT.ExcelPlannerGrid ||
                                dataItem?.PlanningExport?._id === PLANNING_EXPORT.PDFPlannerGrid) && (
                                    <>
                                        <div className="col-md-3 mt-2">
                                            <label className="form-label fw-semibold">{lang.start_label}</label>
                                            <DropDownList
                                                value={startType}
                                                data={["Nominal", "Actual"]}
                                                onChange={(e) => onStartTypeChange(e.value)}
                                                disabled={isExportingMessage}
                                            />
                                        </div>
                                        <div className="col-md-3 mt-2">
                                            <label className="form-label fw-semibold">{lang.duration_label}</label>
                                            <DropDownList
                                                value={durationType}
                                                data={["Nominal", "ActualDuration"]}
                                                onChange={(e) => onDurationTypeChange(e.value)}
                                                disabled={isExportingMessage}
                                            />
                                        </div>
                                        <div className="col-md-3 mt-2">
                                            <label className="form-label fw-semibold">{lang.slot_duration_title_label}</label>
                                            <DropDownList
                                                value={slotDur + ' min'}
                                                data={SLOT_TIMES}
                                                onChange={(e) => { setSlotDur(e.value) }}
                                                disabled={isExportingMessage}
                                            />
                                        </div>
                                        {
                                            isTimeZone && <div className="col-md-3 mt-2">
                                                <label className="form-label fw-semibold">{lang.time_zone_label}</label>
                                                <DropDownList
                                                    name="timeZoneOffset"
                                                    value={dataItem.timeZoneOffset}
                                                    data={timeZones}
                                                    dataItemKey="_id"
                                                    textField="Description"
                                                    onChange={onChange}
                                                    disabled={isExportingMessage}
                                                />
                                            </div>
                                        }
                                        <div className="col-md-3 mt-2">
                                            <label className="form-label fw-semibold"> {lang.epg_template_label}</label>
                                            <DropDownList
                                                data={epgColumns}
                                                name="EpgExport"
                                                textField="Name"
                                                dataItemKey="_id"
                                                value={epgColumn}
                                                onChange={(e) => setEpgColumn(e.target.value)}
                                            />
                                        </div>
                                    </>
                                )}
                            {/* ===== EPG / Break / Custom ===== */}
                            {(dataItem?.PlanningExport?._id === PLANNING_EXPORT.CSVEPG ||
                                dataItem?.PlanningExport?._id === PLANNING_EXPORT.ExcelEPG ||
                                dataItem?.PlanningExport?._id === PLANNING_EXPORT.BreakPattern ||
                                dataItem?.PlanningExport?._id === PLANNING_EXPORT.CustomEPG) && (
                                    <>
                                        {(dataItem?.PlanningExport?._id === PLANNING_EXPORT.CSVEPG ||
                                            dataItem?.PlanningExport?._id === PLANNING_EXPORT.ExcelEPG) && (
                                                <div className="col-md-4 mt-2">
                                                    <label className="form-label fw-semibold"> {lang.epg_template_label}</label>
                                                    <DropDownList
                                                        data={epgColumns}
                                                        name="EpgExport"
                                                        textField="Name"
                                                        dataItemKey="_id"
                                                        value={epgColumn}
                                                        onChange={(e) => setEpgColumn(e.target.value)}
                                                    />
                                                </div>
                                            )}
                                        {dataItem?.PlanningExport?._id === PLANNING_EXPORT.CustomEPG && (
                                            <div className="col-md-4 mt-2">
                                                <label className="form-label fw-semibold"> {lang.report_type_label} </label>
                                                <DropDownList
                                                    data={publishReports}
                                                    name="ReportType"
                                                    textField="Description"
                                                    dataItemKey="SID"
                                                    value={dataItem?.ReportType || null}
                                                    onChange={onChange}
                                                    disabled={isExportingMessage}
                                                />
                                            </div>
                                        )}
                                    </>
                                )}
                        </div>
                        {/* ===== ROW 2: ONLY Planner ===== */}
                        {(dataItem?.PlanningExport?._id === PLANNING_EXPORT.ExcelPlannerGrid ||
                            dataItem?.PlanningExport?._id === PLANNING_EXPORT.PDFPlannerGrid) && (
                                <div className="row g-3 mt-3 align-items-end">
                                    {/* Checkboxes */}
                                    <div className="col-md-12 d-flex gap-4 align-items-center">
                                        <div className="d-flex align-items-center gap-2">
                                            <Checkbox checked={hideNextDayShowContinuation} name="" onChange={(e) => setHideNextDayShowContinuation(e.value)} style={{ marginRight: "3px" }} />
                                            <span>{lang.hide_next_day_show_continuation_label}</span>
                                        </div>
                                        <div className="d-flex align-items-center gap-2 ml-3">
                                            <Checkbox checked={showTitleOnly} name="" onChange={(e) => setShowTitleOnly(e.value)} style={{ marginRight: "3px" }} />
                                            <span>{lang.show_title_only_label}</span>
                                        </div>
                                        <div className="d-flex align-items-center gap-2 ml-3">
                                            <Checkbox checked={showPgRating} name="" onChange={(e) => setShowPgRating(e.value)} style={{ marginRight: "3px" }} />
                                            <span>{lang.show_pg_rating_label}</span>
                                        </div>
                                        <div className="d-flex align-items-center gap-2 ml-3">
                                            <Checkbox checked={isMonthExport} name="" onChange={(e) => setIsMonthExport(e.value)} style={{ marginRight: "3px" }} />
                                            <span>{lang.month_export_label}</span>
                                        </div>
                                        <div className="d-flex align-items-center gap-2 ml-3">
                                            <Checkbox checked={isTimeZone} name="" onChange={(e) => setIsTimeZone(e.value)} style={{ marginRight: "3px" }} />
                                            <span>{lang.time_zone_label}</span>
                                        </div>
                                    </div>
                                </div>
                            )}
                    </div>
                )}
        </BossDialog>
    );
};

export default PlannerExportExcelForm